<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span class="text-muted">Auto-refresh:</span>
      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        boundary="viewport"
      >
        <template #button-content>
          <span>{{ autoRefreshOption.name }} <b-icon-caret-down-fill /></span>
        </template>
        <b-dropdown-header>Refresh interval</b-dropdown-header>
        <b-dropdown-item
          v-for="option in autoRefreshOptions"
          :key="option.value"
          @click.prevent="onChangeAutoRefreshInterval(option.value)"
          :active="isActive(option.value)"
          >{{ option.name }}</b-dropdown-item
        >
      </b-dropdown>
    </div>

    <b-button variant="link" @click="refresh"
      ><b-icon-arrow-repeat /> Refresh</b-button
    >
  </div>
</template>

<script>
export default {
  name: "AutoRefresh",
  computed: {
    autoRefreshInterval() {
      return this.$store.getters.autoRefreshInterval;
    },
    autoRefreshOption() {
      return this.$store.getters.autoRefreshOption;
    },
    autoRefreshOptions() {
      return this.$store.getters.autoRefreshOptions;
    },
  },
  methods: {
    isActive(value) {
      return +value === +this.autoRefreshInterval;
    },
    onChangeAutoRefreshInterval(value) {
      this.$store.dispatch("setAutoRefreshInterval", value);
      this.$emit("change", value);
    },
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
